import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Cart from "../components/cart/Cart";
import Home from "../components/Home";
function Routers() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="home" />} />
      <Route path="home" element={<Home />} />
      <Route path="cart" element={<Cart />} />
    </Routes>
  );
}

export default Routers;
